import { format } from 'date-fns';

const CALENDAR_DATE_FORMAT = 'MMMM yyyy';

export const formatDate = (date: Date) => format(date, CALENDAR_DATE_FORMAT);
